export default {
      id: "icon-sabah-kahvaltisi-usage",
      viewBox: "0 0 507.4 507.4",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-sabah-kahvaltisi",
      toString: function () {
        return this.url;
      }
    }